import { createPageNavigator } from "@-/dev.improve.haniverse.lib.navigator.page";
import type { PageNavigatorQuery } from "@-/dev.improve.haniverse.lib.navigator.page";
import { useGetDeckPageQueries } from "@-/dev.improve.haniverse.routes.nav.app.deck.query";
import { useCallback } from "react";

function useNavigator(pathname: "/(nav)/(app)/decks/today" | "/(nav)/(app)/decks/upcoming") {
  const getDeckPageQueries = useGetDeckPageQueries();

  return useCallback(
    (_variables: void) => {
      const queryOptions = getDeckPageQueries({ kind: "preset", presetKey: "upcoming" });
      const queries: PageNavigatorQuery[] = [queryOptions.collectionsQueryOptions];
      if (queryOptions.kind === "preset-upcoming") {
        queries.push(queryOptions.studyingDeckStudyCardsQueryOptions);
      }
      return {
        href: { pathname },
        queries,
      };
    },
    [getDeckPageQueries, pathname],
  );
}

export const useDeckUpcomingPageNavigator = createPageNavigator<void>({
  useNavigator: () => useNavigator("/(nav)/(app)/decks/upcoming"),
});

export const useDeckTodayPageNavigator = createPageNavigator<void>({
  useNavigator: () => useNavigator("/(nav)/(app)/decks/today"),
});
